(()=>{'use strict';
class Welcome extends HTMLElement{
 connectedCallback(){
  if(this.started)return;
  this.started=true;
  this.popup=this.querySelector('dialog');
  this.form=this.querySelector('[data-welcome-code-form]');
  this.teaser=this.querySelector('.season-gift-live');
  this.preview=!!(window.Shopify?.designMode||new URL(location.href).searchParams.get('yvezi_preview')==='1');
  this.inertOffer=this.dataset.ready!=='true';
  this.key='yvezi-welcome-v1';
  if(!this.popup||!this.form||this.dataset.enabled!=='true'||(this.inertOffer&&!this.preview))return;
  this.querySelectorAll('[data-season-preview]').forEach(el=>el.hidden=!this.inertOffer);
  if(this.inertOffer)this.querySelector('[data-real-success]').hidden=true;
  this.querySelectorAll('.season-x,.season-no,.season-continue').forEach(b=>b.addEventListener('click',()=>this.popup.close()));
  this.teaser.addEventListener('click',()=>this.open());
  this.popup.addEventListener('close',()=>{
   document.documentElement.classList.remove('yvezi-welcome-lock');
   this.priorFocus?.focus({preventScroll:true});
   if(this.priorScroll)window.scrollTo({left:this.priorScroll.x,top:this.priorScroll.y,behavior:'instant'});
   this.set('dismissed',Date.now());
   if(!this.get('code-received'))this.teaser.hidden=false;
  });
  this.popup.addEventListener('click',event=>{
   if(event.target!==this.popup)return;
   const r=this.popup.getBoundingClientRect();
   if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.popup.close();
  });
  this.form.addEventListener('submit',event=>{
   event.preventDefault();
   if(!this.form.reportValidity())return;
   this.form.hidden=true;
   this.querySelector('.season-success').hidden=false;
   this.teaser.hidden=true;
   if(!this.inertOffer)this.set('code-received',true);
   this.querySelector('[data-copy-code]').focus({preventScroll:true});
  });
  this.querySelector('[data-copy-code]').addEventListener('click',()=>this.copyCode());
  this.form.querySelector('[type=submit]').disabled=false;
  if(this.preview){this.timer=setTimeout(()=>this.open(),1800);return}
  if(this.get('code-received'))return;
  if(Date.now()-Number(this.get('dismissed')||0)<7*86400000){this.teaser.hidden=false;return}
  this.timer=setTimeout(()=>{
   if(![...document.querySelectorAll('dialog[open], #shopify-pc__prefs__dialog, #shopify-pc__banner')].some(dialog=>dialog.getClientRects().length&&getComputedStyle(dialog).visibility!=='hidden')&&!document.documentElement.classList.contains('overflow-hidden'))this.open();
   else this.teaser.hidden=false;
  },Number(this.dataset.delay)||18000);
 }
 disconnectedCallback(){clearTimeout(this.timer);document.documentElement.classList.remove('yvezi-welcome-lock')}
 get(key){try{return JSON.parse(localStorage.getItem(this.key+'-'+key)||'null')}catch{return null}}
 set(key,value){try{localStorage.setItem(this.key+'-'+key,JSON.stringify(value))}catch{}}
 open(){
  if(this.popup.open)return;
  this.priorFocus=document.activeElement;
  this.priorScroll={x:window.scrollX,y:window.scrollY};
  this.popup.showModal();
  this.teaser.hidden=true;
  document.documentElement.classList.add('yvezi-welcome-lock');
  this.querySelector(this.form.hidden?'[data-copy-code]':'.season-field').focus({preventScroll:true});
 }
 async copyCode(){
  const code=this.querySelector('[data-welcome-code]');
  const status=this.querySelector('[data-copy-status]');
  try{
   await navigator.clipboard.writeText(code.textContent.trim());
   status.textContent='Copied!';
  }catch{
   const range=document.createRange();
   range.selectNodeContents(code);
   const selection=window.getSelection();
   selection.removeAllRanges();selection.addRange(range);
   status.textContent='Select and copy the code above.';
  }
 }
}
if(!customElements.get('yvezi-welcome'))customElements.define('yvezi-welcome',Welcome);
function web(){let lines='';for(let a=0;a<=90;a+=15){let r=a*Math.PI/180;lines+=`<path d="M0 0L${240*Math.cos(r)} ${240*Math.sin(r)}"/>`}for(let d=35;d<=235;d+=40){let path=`M${d} 0`;for(let a=15;a<=90;a+=15){let r=a*Math.PI/180,prev=(a-7.5)*Math.PI/180;path+=` Q${d*.82*Math.cos(prev)} ${d*.82*Math.sin(prev)} ${d*Math.cos(r)} ${d*Math.sin(r)}`}lines+=`<path d="${path}"/>`}return `<svg viewBox="0 0 250 250" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true">${lines}</svg>`}
class Halloween extends HTMLElement{
 connectedCallback(){if(this.layer||this.dataset.enabled!=='true')return;let end=Date.parse(this.dataset.end+'T00:00:00Z');if(Number.isFinite(end)&&Date.now()>=end&&!window.Shopify?.designMode)return;this.layer=document.createElement('div');this.layer.className='yvezi-halloween-layer';this.layer.setAttribute('aria-hidden','true');this.layer.dataset.motion=this.dataset.motion;this.layer.style.setProperty('--hw-accent',this.dataset.color);this.layer.innerHTML=`<div class="yh-web yh-left">${web()}</div><div class="yh-web yh-right">${web()}</div><div class="yh-hanging"><svg viewBox="0 0 70 160"><path d="M35 0V115" stroke="currentColor" stroke-width=".7"/><g fill="none" stroke="currentColor" stroke-width="2"><path d="M30 128 18 117 10 121M29 132 14 128 6 136M29 137 15 140 12 151M40 128 52 117 60 121M41 132 56 128 64 136M41 137 55 140 58 151"/></g><ellipse cx="35" cy="134" rx="7" ry="10" fill="currentColor"/><circle cx="35" cy="123" r="5" fill="currentColor"/></svg></div><div class="yh-walking"><svg viewBox="0 0 90 70"><g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M35 25 22 12 8 16M34 31 15 28 3 36M34 38 17 45 12 58M35 43 28 57 32 66M55 25 68 12 82 16M56 31 75 28 87 36M56 38 73 45 78 58M55 43 62 57 58 66"/></g><ellipse cx="45" cy="39" rx="12" ry="17" fill="currentColor"/><circle cx="45" cy="21" r="9" fill="currentColor"/></svg></div>`;document.body.append(this.layer)}
 disconnectedCallback(){this.layer?.remove();this.layer=null}
}
if(!customElements.get('yvezi-halloween'))customElements.define('yvezi-halloween',Halloween);
})();
